import { collection } from "@Api/helpers";
import Factory from "@Shared/Factory";
import api from "..";
export const find = (customerId, userId) => {
    const url = `/customers/${customerId}/users/${userId}`;
    return api.get(url).then((result) => Factory.User(result.data.item));
};
export const get = (callback, customerId, inclDel) => {
    const url = `/customers/${customerId}/users`;
    return collection((data) => callback(Factory.User(data)), url, { inclDel });
};
export const post = (user) => {
    return api
        .post(`/customers/${user.customerId}/users`, user.data)
        .then((result) => {
        return Factory.User(result.data.item);
    })
        .catch((error) => {
        throw error.response.data;
    });
};
export const put = (user) => {
    return api
        .put(`/customers/${user.customerId}/users/${user.id}`, user.data)
        .then((result) => {
        return Factory.User(result.data.item);
    });
};
export const del = (user) => {
    return api
        .delete(`/customers/${user.customerId}/users/${user.id}`)
        .then((result) => {
        return result.data.item;
    });
};
export const restore = (user) => {
    return api
        .put(`/customers/${user.customerId}/users/${user.id}/restore`)
        .then((result) => {
        return Factory.User(result.data.item);
    });
};
